// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea9f12fa","455":"c81ffaeb","488":"ea92044f","929":"02cd5233","977":"f8012450"}[chunkId] + ".chunk.js";
};